import { AccountStatus } from "@softmax/product-ux/account";
import type { PlayerResponse } from "@softmax/observatory-client/types";
import { PlayerCredentialCard } from "./player-credential-card";
import type { CredentialOpening } from "./credential-intent";

export function CredentialPlayerList({
  players,
  ready,
  unavailable,
  error,
  refreshing,
  onCredential,
  onRename,
  onRefresh,
}: {
  readonly players: readonly PlayerResponse[];
  readonly ready: boolean;
  readonly unavailable: boolean;
  readonly error: Error | null;
  readonly refreshing: boolean;
  readonly onCredential: (opening: CredentialOpening) => void;
  readonly onRename: (player: PlayerResponse) => void;
  readonly onRefresh: () => Promise<boolean>;
}) {
  if (unavailable || !ready)
    return (
      <AccountStatus
        state={
          error
            ? { status: "error", message: error.message }
            : { status: "loading" }
        }
        onRetry={() => void onRefresh()}
      />
    );

  return (
    <>
      {error ? (
        <AccountStatus
          state={{
            status: "error",
            message: `Could not refresh players: ${error.message}`,
          }}
          onRetry={() => void onRefresh()}
        />
      ) : null}
      {players.length === 0 ? (
        <AccountStatus
          state={{
            status: "empty",
            message: "Create your first player to use player credentials.",
          }}
          onRetry={() => {}}
        />
      ) : (
        players.map((player) => (
          <PlayerCredentialCard
            key={player.id}
            player={player}
            onCredential={onCredential}
            onRename={() => onRename(player)}
            refreshing={refreshing}
            refreshError={error?.message}
            onRefresh={onRefresh}
          />
        ))
      )}
    </>
  );
}
